<template>
  <div>
    <h6
      style="font-weight: 400; margin: 0px !important; padding: 0px !important"
    >
      {{ VALUE }}
    </h6>
  </div>
</template>
<script>
export default {
  data() {
    return {
      VALUE: ""
    };
  },
  created() {
    this.VALUE = this.currencyFormatter(
      this.params.value,
      this.params.data.CURRCODE
    );
  },
  methods: {
    currencyFormatter(currency, sign) {
      try {
        if (currency == "" || typeof currency == "undefined") {
          return "";
        } else {
          var sansDec = currency.toFixed(2);
          var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          return `${formatted}` + " " + sign;
        }
      } catch (error) {}
    }
  }
};
</script>
